import _ from "lodash";

export const SORTER_MAPPING: any = {
  ascend: "asc",
  descend: "desc",
};
export const DEFAULT_SORTER = (sorter: any) => {
  const key: string = _.get(sorter, "column.key");
  if (key) return { [key]: SORTER_MAPPING[sorter.order] };
  return null;
};
export const DEFAULT_FILTER = (filter: any) => {
  if (_.isArray(filter)) {
    return _.merge({}, ..._.compact(filter));
  }
  const rtn = filter;
  return rtn;
};

export const getFilterValues = (params: object) => {
  return {
    ...params,
    sorters: (() => {
      let sorters: any = {};
      try {
        const target = _.get(params, "sorters", "");
        if (_.isString(target)) {
          sorters = JSON.parse(_.get(params, "sorters", ""));
        } else {
          sorters = target;
        }
      } catch (err) {
        // console.log(err)
      }
      return sorters;
    })(),
    filters: (() => {
      let filters: any = {};
      try {
        const target = _.get(params, "filters", "");
        if (_.isString(target)) {
          filters = JSON.parse(_.get(params, "filters", ""));
        } else {
          filters = target;
        }
      } catch (err) {
        // console.log(err)
      }
      return filters;
    })(),
    page: (() => {
      let page = 1;

      try {
        page = parseInt(_.get(params, "page", "")) || page;
      } catch (err) {
        // console.log(err)
      }
      return page;
    })(),
    limit: (() => {
      let limit = 10;
      try {
        limit = parseInt(_.get(params, "limit", "")) || limit;
      } catch (err) {
        // console.log(err)
      }
      return limit;
    })(),
    pageSize: (() => {
      let pageSize = 10;
      try {
        pageSize = parseInt(_.get(params, "pageSize", "")) || pageSize;
      } catch (err) {
        // console.log(err)
      }
      return pageSize;
    })(),
  };
};
